var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Loading Page")]),_c('LoadingPage',[_c('template',{slot:"title"},[_vm._v("\n      Something is happening please wait...\n    ")])],2),_c('LoadingPage',[_c('template',{slot:"title"},[_vm._v("\n      Your documents are loading...\n    ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }